import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Color, Radius, Spacing, size } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Text from "@ui-kit/form/text";
import { tr } from "@radarly/i18n";
import { PanelType } from "@radarly/shared/panels/card-edition/sidebar";
import Radios from "./radios";

export interface IProps {
  title: string;
  color: string;
  setColor: (color: string) => void;
  locale?: Locale;
  setPanel: (panel: { type: PanelType; index?: number }) => void;
  closePanel: () => void;
}

const ColorInput = styled.div`
  position: relative;
`;

const ColorSquare = styled.div`
  border-radius: ${Radius.Small};
  ${size(16)};
  position: absolute;
  top: 4px;
  left: 28px;
`;

const StyledText = styled(Text)`
  margin: ${Spacing.ExtraSmall} 0 0 ${Spacing.Large};
  input {
    padding-left: 32px;
  }
`;

const PanelsCardEditionSidebarColor = ({
  title,
  color = "",
  setColor,
  locale = Locale.English,
  setPanel,
}: IProps) => {
  const [colorMode, setColorMode] = useState(
    color !== "" ? "custom" : "default"
  );
  const [customColor, setCustomColor] = useState(color);
  const selectColorMode = (mode) => {
    if (mode === "custom") {
      //apply default lkf color
      !customColor && setCustomColor(Color.LightSeaGreen);
    }
    setColorMode(mode);
  };
  useEffect(() => {
    if (colorMode === "default") {
      setColor("");
    } else {
      setColor(customColor);
    }
  }, [colorMode, setColor, customColor]);
  return (
    <div>
      <Radios
        label={title}
        onChange={(id) => selectColorMode(id as string)}
        value={colorMode}
        inline={false}
        options={[
          {
            value: "default",
            label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::COLOR_DEFAULT"),
          },
          {
            value: "custom",
            label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::COLOR_CUSTOM"),
          },
        ]}
      />
      {colorMode === "custom" && (
        <ColorInput
          onClick={() => setPanel({ type: PanelType.Color, index: undefined })}
        >
          <StyledText
            value={customColor}
            onChange={setCustomColor}
            variant="primary"
            $size="s"
          />
          <ColorSquare
            style={{ backgroundColor: customColor, height: 24, width: 24 }}
          />
        </ColorInput>
      )}
    </div>
  );
};

export default PanelsCardEditionSidebarColor;
